"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._syncMV = exports._getSyncHistory = exports._getLastSync = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const endpoint = (moduleName) => {
    switch (moduleName) {
        case 'adjustment_production':
            return '/adjustment/stockpile';
        case 'adjustment_hauling':
            return '/adjustment/SiloHopper';
        case 'report_production':
            return '/report/prod-statistic';
        case 'report_hauling':
            return '/report/hauling-statistic';
    }
};
const _getLastSync = (moduleName) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + endpoint(moduleName) + '/get-last-sync';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: undefined
        };
    }
});
exports._getLastSync = _getLastSync;
const _getSyncHistory = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const { moduleName, skip, take, filter, sort } = arg;
    const url = String(process.env.API_ENDPOINT) + endpoint(moduleName) + '/sync-history';
    const filterString = filter ? JSON.stringify({
        filters: filter.filters,
        logic: filter.logic
    }) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: []
        };
    }
});
exports._getSyncHistory = _getSyncHistory;
const _syncMV = (moduleName, modified_by = 'System') => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + endpoint(moduleName) + '/sync';
    const config = {
        params: { modified_by },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.post(url, null, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: undefined
        };
    }
});
exports._syncMV = _syncMV;
